import React from 'react'

const Fourwheel = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve" width={width} height={height}>
    <g transform="translate(512 512) rotate(-180)">
      <path
        fill={color}
        d="M387.439 170.067h-9.824c-15.123 0-27.496-12.373-27.496-27.496V60.687c0-15.123 12.373-27.496 27.496-27.496h9.824c15.123 0 27.496 12.373 27.496 27.496v81.883c.001 15.124-12.373 27.497-27.496 27.497zM133.786 170.067h-10.424c-15.244 0-27.716-12.472-27.716-27.716V60.907c0-15.244 12.472-27.716 27.716-27.716h10.424c15.244 0 27.716 12.472 27.716 27.716v81.444c0 15.244-12.472 27.716-27.716 27.716z"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth={20}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M351.532 118.951l.036 25.573c-.095 13.402 10.835 24.333 24.237 24.333h15.208c13.402 0 24.333-10.931 24.333-24.333V59.83c0-13.402-10.931-24.333-24.333-24.333h-15.208c-13.402 0-24.333 10.931-24.333 24.333l.036 24.808h-190.7l.036-24.808c0-13.402-10.931-24.333-24.333-24.333h-15.208c-13.402 0-24.333 10.931-24.333 24.333v84.694c0 13.402 10.931 24.333 24.333 24.333h15.208c13.402 0 24.333-10.931 24.237-24.333l.036-25.573h76.452v275.748h-76.452l-.036-25.573c.095-13.402-10.835-24.333-24.237-24.333h-15.208c-13.402 0-24.333 10.931-24.333 24.333v84.694c0 13.402 10.931 24.333 24.333 24.333h15.208c13.402 0 24.333-10.931 24.333-24.333l-.036-24.808h190.7l-.036 24.808c0 13.402 10.931 24.333 24.333 24.333h15.208c13.402 0 24.333-10.931 24.333-24.333v-84.694c0-13.402-10.931-24.333-24.333-24.333h-15.208c-13.402 0-24.333 10.931-24.237 24.333l-.036 25.573h-77.195V118.951h77.195z"
      />
    </g>
  </svg>
)
export default Fourwheel
